import React, { createContext, useState, useRef } from 'react';
import PropTypes from 'prop-types';

const initialPopUps = [];

export const InterceptorPopUpContext = createContext(initialPopUps);

const InterceptorPopUpContextProvider = ({ children }) => {
  
  const [popUps, setPopUps] = useState(initialPopUps);
  const clearListTimeout = useRef();

  const addPopUp = (text) => {
    let newPopUp = {text};
    setPopUps(popUps => [...popUps, newPopUp]);
    updateClearListTimeout();
  };

  const removePopUp = (ind) => {
    setPopUps( popUps => [...popUps.splice(ind, 1)]);
  };

  const updateClearListTimeout = () => {
    // Clears popUps after the last popUp has slid back outside the screen
    if (clearListTimeout.current) clearTimeout(clearListTimeout.current);
    clearListTimeout.current = setTimeout(() => setPopUps([]), 4500);
  };

  return (
    <InterceptorPopUpContext.Provider value={{popUps, addPopUp, removePopUp}}>
      {children}
    </InterceptorPopUpContext.Provider>
  );
};

InterceptorPopUpContextProvider.propTypes = {
  children: PropTypes.node
};

export default InterceptorPopUpContextProvider;
